var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',{staticClass:"navigation"},_vm._l((_vm.routes),function(route){return _c('router-link',{key:route.name,attrs:{"to":route,"tag":"li"}},[_vm._v(" "+_vm._s(route.name)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }